export const CART_TOGGLE_OPEN = 'CART_TOGGLE_OPEN';
export const CART_TOGGLE_CLOSE = 'CART_TOGGLE_CLOSE';
export const CART_TOGGLE_RESET = 'CART_TOGGLE_RESET';
